import { currentUserQuery } from "@/hooks/useUser.tsx";
import { needsStepUp } from "@/shared/stepUp.ts";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { stepUpHref } from "./stepUp.ts";

/**
 * For surfaces that start a gated flow themselves: whether this account must
 * prove its number first, and the step-up link that returns here.
 */
export const useStepUp = () => {
  // The cached account, not a second fetch and not the context hook: this runs
  // in every connector card, and mounting preferences there costs more than it
  // answers. An unloaded cache reads as "no step-up", which the server refuses
  // anyway.
  const { data } = useQuery({ ...currentUserQuery(), enabled: false });
  const [location] = useLocation();
  return {
    required: needsStepUp(data?.user?.phoneVerifiedBy),
    href: stepUpHref(location + window.location.search),
  };
};
